import Vue from 'vue/dist/vue.esm.js';
import VCalendar from 'v-calendar';
import CalendarContainer from './components/Calendar.vue';

const appEl = document.getElementById('app');
if (appEl) {
  Vue.use(VCalendar);

  // eslint-disable-next-line no-unused-vars
  const app = new Vue({
    el: appEl,
    components: {
      CalendarContainer
    }
  });
}
